import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage, Language } from "@/contexts/LanguageContext";
import { getLanguageFromPath, getPathWithLanguage, getPathWithoutLanguage } from "@/hooks/useLanguageFromUrl";
import useDocumentMeta from "@/hooks/useDocumentMeta";

interface LanguageRouterProps {
  children: React.ReactNode;
}

const SUPPORTED_LANGUAGES: Language[] = ["pt", "en", "es", "fr", "zh"];

const LanguageRouter = ({ children }: LanguageRouterProps) => {
  const { language, setLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  // Update document meta tags based on language and route
  useDocumentMeta();

  // Sync language from URL on mount and URL changes
  // Only update language if the URL explicitly contains a language prefix
  useEffect(() => {
    const urlLanguage = getLanguageFromPath(location.pathname);
    
    if (urlLanguage && urlLanguage !== language) {
      // URL has a different language prefix, update context to match URL
      setLanguage(urlLanguage);
    }
    // Note: We no longer reset to Portuguese when there's no prefix
    // This allows the language to persist across internal navigation
  }, [location.pathname]);

  return <>{children}</>;
};

export default LanguageRouter;
